// AWS configuration validator
// Shared validation logic for all environment configurations

/**
 * Validates AWS configuration object to ensure all required fields are present
 * @param config AWS configuration object
 * @returns true if valid, false otherwise
 */
export function validateAwsConfig(config: any): boolean {
  try {
    // Check Auth configuration
    if (!config.Auth?.Cognito) throw new Error('Missing Auth.Cognito configuration');
    if (!config.Auth.Cognito.userPoolId) throw new Error('Missing Auth.Cognito.userPoolId');
    if (!config.Auth.Cognito.userPoolClientId) throw new Error('Missing Auth.Cognito.userPoolClientId');
    if (!config.Auth.Cognito.identityPoolId) throw new Error('Missing Auth.Cognito.identityPoolId');
    
    // Check Storage configuration
    if (!config.Storage?.S3) throw new Error('Missing Storage.S3 configuration');
    if (!config.Storage.S3.region) throw new Error('Missing Storage.S3.region');
    if (!config.Storage.S3.bucket) throw new Error('Missing Storage.S3.bucket');
    
    // Check API configuration
    if (!config.API?.REST?.FoodTrackerAPI) throw new Error('Missing API.REST.FoodTrackerAPI configuration');
    if (!config.API.REST.FoodTrackerAPI.endpoint) throw new Error('Missing API.REST.FoodTrackerAPI.endpoint');
    if (!config.API.REST.FoodTrackerAPI.region) throw new Error('Missing API.REST.FoodTrackerAPI.region');
    
    // Validate URL format for endpoint
    const endpoint = config.API.REST.FoodTrackerAPI.endpoint;
    if (endpoint && !endpoint.trim().match(/^https?:\/\/.+/)) {
      throw new Error('API endpoint must be a valid URL starting with http:// or https://');
    }
    
    return true;
  } catch (error) {
    console.error('AWS Configuration Error:', error instanceof Error ? error.message : 'Unknown error');
    return false;
  }
}